/* External dependencies **/
import { connect } from "react-redux";

/* Internal dependencies */
import MobileHeader from "../components/MobileHeader";
import { logout } from "shared-frontend/redux/actions/user";
import { getPathname } from "../redux/selectors/router/location";
import { getSitesById } from "shared-frontend/redux/selectors/entities/sites";
import { getAllSubscriptionsById } from "shared-frontend/redux/selectors/entities/subscriptions";
import { getLogoutError, isLoggingOut } from "shared-frontend/redux/selectors/user/user";


export const mapStateToProps = ( state ) => {
	const path = getPathname( state ).split( "/" );
	let pageTitle = "";

	const id = path.pop();
	const type = path.pop();

	// Set page title for sites and subscriptions detail pages.
	if ( type === "sites" && id ) {
		const site = getSitesById( state )[ id ];
		pageTitle = site ? site.hostname : "";
	} else if ( type === "subscriptions" && id ) {
		const subscription = getAllSubscriptionsById( state )[ id ];
		pageTitle = subscription ? subscription.name : "";
	}

	return {
		pageTitle,
		loggingOut: isLoggingOut( state ),
		logoutError: getLogoutError( state ),
	};
};

export const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		onLogoutClick: () => {
			dispatch( logout() );
		},
		onBackClick: () => {
			let backSteps = -1;
			// When the skip link has been activated, go back by two steps in the history.
			if ( ownProps.history.location.hash === "#content" ) {
				backSteps = -2;
			}
			ownProps.history.go( backSteps );
		},
	};
};

const MobileHeaderContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
)( MobileHeader );

export default MobileHeaderContainer;
